module.exports = __webpack_public_path__ + "static/media/verotexticon.986053ab.png";